import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraEmpty } from "../../../../components/AtiraEmpty";
import { SpinnerFullScreen } from "../../../../components/SpinnerFullScreen";
import { dashboardSliceSelectors } from "../../../../redux/dashboard/dashboard.selector";
import { useAppSelector } from "../../../../redux/store";
import { userSliceSelectors } from "../../../../redux/user/user.selector";
import { TestIDs } from "../../../../tests/types/testIds";
import { Spacing } from "../../../../theme/Spacing";
import { DashboardColumns } from "../DashboardPanel";
import { WidgetLatestEntries } from "../widgets/WidgetLatestEntries";
import { WidgetStatsClosedEntities } from "../widgets/WidgetStatsClosedEntities";
import { DashboardTodayAttention } from "./DashboardTodayAttention";
import { DashboardTodayKpis } from "./DashboardTodayKpis";
import { DashboardTodaySources } from "./DashboardTodaySources";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.m};
`;

export const DashboardToday: React.FC = () => {
  const { t } = useTranslation();
  const today = useAppSelector(dashboardSliceSelectors.selectToday);
  const failed = useAppSelector(dashboardSliceSelectors.selectTodayFailed);
  const isMember = useAppSelector(userSliceSelectors.selectIsUserOrgMember);

  if (!today) {
    return failed ? (
      <AtiraEmpty description={t("dashboard.today.error")} />
    ) : (
      <SpinnerFullScreen />
    );
  }

  return (
    <Wrapper data-testid={TestIDs.dashboard.today.wrapper}>
      <DashboardTodayKpis today={today} />

      <DashboardColumns
        $ratio={
          today.entries ? "minmax(0, 3fr) minmax(0, 2fr)" : "minmax(0, 1fr)"
        }
      >
        <DashboardTodayAttention today={today} />
        {today.entries ? (
          <DashboardTodaySources sources={today.entrySources} />
        ) : null}
      </DashboardColumns>

      {!isMember ? (
        <DashboardColumns>
          <WidgetLatestEntries />
          <WidgetStatsClosedEntities />
        </DashboardColumns>
      ) : null}
    </Wrapper>
  );
};
